import { createContext, useContext, useEffect, useState } from "react";
import { api, tokenStore } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null); // null = checking, false = signed out

  useEffect(() => {
    if (!tokenStore.get()) return setAdmin(false);
    api.get("/auth/me").then((r) => setAdmin(r.data)).catch(() => {
      tokenStore.clear();
      setAdmin(false);
    });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    tokenStore.set(data.token);
    setAdmin({ id: data.id, email: data.email, name: data.name });
  };
  const logout = async () => {
    tokenStore.clear();
    setAdmin(false);
  };

  return <AuthContext.Provider value={{ admin, login, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
